module.exports = {
  node: {  
    baseUrl: "https://apply-node.equitysalesfinance.com/api",
      devUrl: "https://devapply-node.equitysalesfinance.com/api",
      stageUrl: "https://stage-apply-node.equitysalesfinance.com/api",
    auth: {
      console: {
        url: "/auth/console",
        payload: {
          code: "",
          pin: "",
        },
      },
      signup: {
        url: "/auth/sign-up-url",
        payload: {
          url: "",
        },
      },
      cosignup: {
        url: "/auth/cosign-up-url",
        payload: {
          url: "",
        },
      },
    },
    console : {
      fnGetMerchantUrls: {
        url: "/console/fn-get-merchant-urls",
        payload: {
          code: "",
          pin: "",
        },
      },
      fnShareMerchantUrlEmail: {
        url: "/console/fn-share-merchant-url-email",
        payload: {
          firstname: "",
          lastname: "",
          email: "",
        },
      },
      fnShareMerchantUrlSms: {
        url: "/console/fn-share-merchant-url-sms",
        payload: {
          cellphone: "",
        },
      },
      fnGetSignupApplications: {
        url: "/console/fn-get-signup-applications",
        payload: {
          cellphone: "",
        },
      },
      fnInviteShareEmail: {
        url: "/console/fn-invite-share-email",
        payload: {
          signup_id : "",
          firstname: "",
          lastname: "",
          email: "",
        },
      },
      fnInviteShareSms: {
        url: "/console/fn-invite-share-sms",
        payload: {
          signup_id : "",
          firstname: "",
          lastname: "",
          cellphone: "",
        },
      },
      fnConnect: {
        url: "/console/fn-connect",
        payload: {
          signup_id : "",
          co_signer_id : "",
        },
      },
    }, 
    application : {
      fnSsnTestSubjectVerification: {
        url: "/application/fn-ssn-test-subject-verification",
        payload: {
          cellphone: "",
        },
      },
      fnAddressVerification: {
        url: "/application/fn-address-verification",
        payload: {
          cellphone: "",
        },
      },
      fnSetSignUp: {
        url: "/application/fn-create-sign-up",
        payload: {
          data: "",
        },
      },
      fnDeliverAccessCode: {
        url: "/application/fn-deliver-access-code",
        payload: {
          data: "",
        },
      },
      fnApplicationCompleteEmail: {
        url: "/application/fn-application-complete-email",
        payload: {
          data: "",
        },
      },
      fnStartCoSigner: {
        url: "/application/fn-start-co-signer",
        payload: {
          data: "",
        },
      },
      fnInviteCoEmail: {
        url: "/application/fn-invite-co-email",
        payload: {
          data: "",
        },
      },
      fnInviteCoSms: {
        url: "/application/fn-invite-co-sms",
        payload: {
          data: "",
        },
      },
    },   
  },
}
